import { FieldValues, Path, PathValue } from 'react-hook-form';
import Patterns from '../../../../../../../utils/pattern/patterns';

const withTextValue = (value: FieldValues[string]) =>
  value && typeof value === 'string';

export type TextFieldValueType = PathValue<FieldValues, Path<FieldValues>>;

export const isValidPostcode = (value: TextFieldValueType, msg: string) => {
  if (withTextValue(value) && !Patterns.isPostcode(value)) {
    return msg;
  }
};

export const isValidInFrontChars = (value: TextFieldValueType, msg: string) => {
  if (withTextValue(value) && !Patterns.isInFrontAllowedChars(value)) {
    return msg;
  }
};

export const isValidEmail = (value: TextFieldValueType, msg: string) => {
  if (withTextValue(value) && !Patterns.isEmail(value)) {
    return msg;
  }
};

export const isValidFormat = (
  value: TextFieldValueType,
  format: string,
  msg: string,
) => {
  const regex = new RegExp(`^${format}$`);
  const isValid = regex.test(value);
  if (withTextValue(value) && !isValid) {
    return msg;
  }
};
